import _Map from "@babel/runtime-corejs3/core-js/map";
//
//
//
//

let svgCache = new _Map();
import { defineComponent } from "@vue/composition-api";
import DOMPurify from "dompurify";
export default defineComponent({
  name: "TimelineIcon",
  props: {
    src: {
      type: String,
      required: true
    },
    classname: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    if (!svgCache.has(this.src)) {
      try {
        svgCache.set(this.src, fetch(this.src).then(t => DOMPurify.sanitize(t.text())));
      } catch (e) {
        svgCache.delete(this.src);
      }
    }
    if (svgCache.has(this.src)) {
      this.$el.innerHTML = await svgCache.get(this.src);
    }
  }
});